import React, {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Button} from 'components';


interface IEDDASubmittedProps {
}

const EDDASubmitted: React.FC<IEDDASubmittedProps> = () => {
    const [search] = useSearchParams();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const requestType = search.get('requestType');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const status = search.get('status');
    const next = search.get('next') || 'abnk://sg';

    let heading = 'eGIRO request cancelled'
    let description = "You didn't authorize us as a Billing Organization of your eGIRO request. If you think this is a mistake, please try again."
    if (status === 'Success') {
        heading = 'eGIRO request submitted'
        description = "It should be complete in a few minutes. When it's done, you'll be able to select your bank account as an eDDA payment method."
    }

    const handleOk = () => {
        window.location.replace(next);
    };

    useEffect(() => {
    }, []);

    return (
        <div>
            <div className="h-screen flex justify-center items-center pt-14 md:pt-0 pb-40 px-3">
                <div className="flex flex-col">
                    <h1 className="text-center text-xl mb-4 font-medium">{heading}</h1>
                    <p className="text-center max-w-2xl mb-10">
                        {description}
                    </p>
                    <div className="flex justify-center">
                        <Button text="OK" variant={status === 'Success' ? 'primary' : 'warningPrimary'} onClick={handleOk}/>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default EDDASubmitted;
